import { App } from './App'
import { useAppSelector, useAppDispatch } from './redux/redux-hooks'
import { ViewTimelineActions } from './redux/slices/view-timeline-slice'

/**
 * Performs necessary first-time setups so the app doesn't implode on
 * load.
 */
export const SetupStateWrapper = (): JSX.Element | null => {

    const timelineState = useAppSelector(state => state.viewTimeline)
    const appDisp = useAppDispatch()

    if (timelineState.editingFight == null) {

        if (timelineState.storedFights.length <= 0) {
            appDisp(ViewTimelineActions.createFight({ name: "Untitled" }))
        } else {

            const fightData = timelineState.storedFights[0]
            appDisp(ViewTimelineActions.selectFight({ fightId: fightData.fight.id }))

        }

        return null
    }

    return (
        <App />
    )
}